module.exports = __webpack_public_path__ + "assets/icons/Lupe-minus.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Lupe-minus.png
// module id = 529
// module chunks = 0